import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, firstValueFrom, of, take, timeout } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { MemberService } from '../services/member.service';

@Injectable({
  providedIn: 'root'
})
export class CustomGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private memberService: MemberService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    await firstValueFrom(
      this.memberService.generalConfigLoaded$.pipe(
        take(1),
        timeout(3000),
        catchError(() => of(undefined))
      )
    );

    const enableLoggedArea = localStorage.getItem('enableLoggedArea');
    const enableNewMembership = localStorage.getItem('enableNewMembership');
    const enablePortal = localStorage.getItem('enablePortal');
    const messageLoggedArea = localStorage.getItem('messageLoggedArea');
    const messageNewMembership = localStorage.getItem('messageNewMembership');
    const messagePortal = localStorage.getItem('messagePortal');
    const isDependent = localStorage.getItem('isDependent');
    const isCeara = this.authService.isCeara;
    const useFanBase = this.authService.useFanBase;
    const fanBaseUrl = isCeara ? 'https://login.vozaoid.com' : 'https://login-vozao.fantest.com.br';
    const redirectUrl = isCeara ? 'https://sociovozao.com' : 'https://sociotorcedordev-clube.efuti.com.br';

    let customGuardResponse = true;

    if (enablePortal === 'false') {
      this.router.navigate([Routes.NotFoundPage, { message: messagePortal }]);
      return false;
    }

    const isBackoffice = !!route.queryParamMap.get('backoffice');

    if (useFanBase && (route.routeConfig?.path?.startsWith('cadastro-socio') || (route.routeConfig?.path?.startsWith('login') && !isBackoffice))) {
      window.location.href = `${fanBaseUrl}/authorize?response_type=code&scope=openid profile&client_id=23ingressosa&redirect_uri=${redirectUrl}/callback`;
      return false;
    }

    switch (route.routeConfig?.path) {
      case Routes.Login:
      case Routes.ChangePassword:
        customGuardResponse = enableLoggedArea === 'true';
        if (!customGuardResponse) this.router.navigate([Routes.NotFoundPage, { message: messageLoggedArea }]);
        break;
      case Routes.DashboardDependente:
        customGuardResponse = isDependent === 'true';
        if (!customGuardResponse) this.router.navigate([Routes.NotFoundPage, { message: messageLoggedArea }]);
        break;
      case Routes.Register:
      case Routes.CompleteData:
      case Routes.FinishPayment:
      case Routes.Welcome:
        customGuardResponse = enableNewMembership === 'true';
        if (!customGuardResponse) this.router.navigate([Routes.NotFoundPage, { message: messageNewMembership }]);
        break;
      default:
        break;
    }

    return customGuardResponse;
  }
}

enum Routes {
  Home = '',
  Login = 'login',
  Register = 'cadastro-socio',
  CompleteData = 'completar-dados',
  DashboardDependente = 'dashboard-dependente',
  FinishPayment = 'finalizar-pagamento/:operation',
  Welcome = 'finalizar-pagamento/:operation/seja-bem-vindo',
  ChangePassword = 'alterar-senha',
  NotFoundPage = '/not-found-page',
}
